import { render, staticRenderFns } from "./ServiceDetailsModal.vue?vue&type=template&id=5dfb70f3&scoped=true&"
import script from "./ServiceDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailsModal.vue?vue&type=style&index=0&id=5dfb70f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfb70f3",
  null
  
)

export default component.exports